// {{WORKTREE_ROOT}}/picosponsorconsole/app/components/shell/SkipLink.tsx
// PLAN2 WP10 — §7.10. The hash href is allowed by the anchors guard (only "/..." hrefs need PLAN-ANCHOR-OK).
import { useT } from "~/utils/locale";
import { TESTIDS } from "~/utils/testids";

export function SkipLink() {
  const t = useT();
  return (
    <a href="#main" data-testid={TESTIDS.shell.skipLink}
      className="sr-only focus:not-sr-only focus:fixed focus:start-3 focus:top-3 focus:z-50 focus:bg-ink focus:px-4 focus:py-2.5 focus:text-14 focus:font-bold focus:text-on-ink focus-visible:outline focus-visible:outline-3">
      {t("a11y", "skip-to-content")}
    </a>
  );
}
